
export default () => {
    const siteHeaderEl = document.querySelector('.site-header');
    const headerNavEl = siteHeaderEl.querySelector('.site-header__nav');

    // Toggla menyn
    $('.site-header__nav-toggle').click(() => {
        document.body.classList.toggle('stop-scrolling');
        siteHeaderEl.classList.toggle('site-header--menu-open');

        const hidden = headerNavEl.getAttribute('aria-hidden');
        headerNavEl.setAttribute('aria-hidden', hidden === 'true' ? 'false' : 'true');
    });

    $(document).ready(function(){
        $('#menu-main_navigation, #menu-main_navigation_en').css('opacity', 1);
    });

    var vwidth = $(window).width();
    if($(".grow").length == 0) {
        $('<span class="grow"><i class="far fa-angle-down"></i></span>').insertAfter('#main-nav ul li.menu-item-has-children > a');
    }
    $('.menu-item-has-children').each(function(){
        if(vwidth > 780) {
            $(this).click(function (){
                if(!$(this).hasClass("open")) {
                    $(this).addClass("open");
                    $(this).children(".sub-menu").slideDown(400);
                    var menuItem = $(this);
                    $(document).mouseup(function(e){
                        if(!menuItem.is(e.target) && menuItem.has(e.target).length === 0) {
                            menuItem.removeClass("open");
                            menuItem.children(".sub-menu").slideUp(400);
                        }
                    });
                } else {
                    $(this).removeClass("open");
                    $(this).children(".sub-menu").slideUp(400);
                }
            });
        } else {
            $(this).click(function(){
                $(this).children('.sub-menu').slideToggle(400);
                $(this).toggleClass('closed');
            })
        }
    });
    addVideoClicks();
    function addVideoClicks(){
        if($('.posts__post').find('.video').length > 0) {
            $('.posts__post').find('.video').each(function() {
                $(this).click(function(){
                    $(this).addClass('play');
                    $(this).find('.video-iframe')[0].src += "?autoplay=1";
                });
            });
        }
        if($('.post .image-container').find('.video').length > 0) {
            $('.post .image-container').each(function() {
                $(this).click(function(){
                    $(this).addClass('play');
                    $(this).find('.video-iframe')[0].src += "?autoplay=1";
                });
            });
        }
    }
};
